import { render, staticRenderFns } from "./AddExpiries.vue?vue&type=template&id=252d837a&"
import script from "./AddExpiries.vue?vue&type=script&lang=js&"
export * from "./AddExpiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports